// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5541":"6e5611b5","6097":"461ff25b","7615":"6e5611b5"}[chunkId] + ".chunk.css";
};